import Lookup from './lookup.js';

export default class OwnershipType extends Lookup
{
    
}
